import { cacheDom } from "../utils/QuerySelectors.js"
import { setOpen, setAddress } from '../apps/store/addressSlice'
import store from '../apps/store/store'
import { getXgenProducts } from '../utils/Product.js'

const dom = {}
const qs = {
  email: 'type="email"',
  password: 'type="password"',
  confirmPassword: 'data-confirm-password',
  submit: 'data-account-submit',
  loginForm: 'data-customer-login',
  recoverForm: 'data-customer-recover',
  registerForm: 'data-customer-register',
  resetForm: 'data-customer-reset-password',
  addressAdd: 'data-address-add', 
  newAddressData: 'data-new-address-data',
  wishlist: 'data-account-wishlist',
  wishlistCount: 'data-account-wishlist-count',
  wishlistActions: 'data-account-wishlist-actions',
  removeAllFromWishlist: 'data-account-wishlist-remove-all',
  shareWishlist: 'data-account-wishlist-share',
  shareHtml: 'data-wishlist-share',
  shareSuccessHtml: 'data-wishlist-share-success',
  shareSendBtn: 'data-wishlist-share-send',
  shareSenderName: 'data-wishlist-share-name',
  shareToEmail: 'data-wishlist-share-email',
  shareMessage: 'data-wishlist-share-message',
  continueShopping: 'data-account-continue-shopping',
}
const qsAll = {
  accountNavs: 'data-account-item',
  accountUrls: 'data-account-url',
  editAddressBtns: 'data-address-edit',
  removeFromWishlist: 'data-wishlist-remove',
  removeAddressBtns: 'data-confirm-message',
}

const setupForm = (form) => {
  const emailField = form.querySelector(`[${qs.email}]`)
  const emailWrap = emailField ? emailField.closest('.input-wrap') : null
  const passwordField = form.querySelector(`[${qs.password}]`)
  const passwordWrap = passwordField ? passwordField.closest('.input-wrap') : null

  form.querySelector(`[${qs.submit}]`).addEventListener('click', (e) => {
    if(emailWrap && form.querySelector(`[${qs.email}]`).value.trim() == '') {
      e.preventDefault()
      if(emailWrap.querySelector('.input-error')) emailWrap.querySelector('.input-error').remove()
      emailWrap.innerHTML += '<p class="input-error">Cannot be blank</p>'
      emailWrap.querySelector(`[${qs.email}]`).addEventListener('keypress', () => {
        if(emailWrap.querySelector('.input-error')) emailWrap.querySelector('.input-error').remove()
      })
    }
    if(passwordWrap) {
      if(passwordField.value == '') {
        e.preventDefault()
        if(passwordWrap.querySelector('.input-error')) passwordWrap.querySelector('.input-error').remove()
        passwordWrap.innerHTML += '<p class="input-error">Cannot be blank</p>'
        passwordWrap.querySelector(`[${qs.password}]`).addEventListener('keypress', () => {
          if(passwordWrap.querySelector('.input-error')) passwordWrap.querySelector('.input-error').remove()
        })
      }

      const confirmPassField = form.querySelector(`[${qs.confirmPassword}]`)
      const confirmPassWrap = confirmPassField ? confirmPassField.closest('.input-wrap') : null
      if(confirmPassField && passwordField.value != confirmPassField.value) {
        e.preventDefault()
        if(confirmPassWrap.querySelector('.input-error')) confirmPassWrap.querySelector('.input-error').remove()
        confirmPassWrap.innerHTML += '<p class="input-error">Passwords don’t match</p>'
        confirmPassWrap.querySelector(`[${qs.confirmPassword}]`).addEventListener('keypress', () => {
          if(confirmPassWrap.querySelector('.input-error')) confirmPassWrap.querySelector('.input-error').remove()
        })
      }
    }
  })
}

const updateActionsVisibility = (swatProducts) => {
  if(swatProducts.length > 0) {
    dom.wishlistActions.classList.remove('!hidden')
    dom.wishlistActions.classList.add('flex')
    dom.continueShopping.classList.remove('flex')
    dom.continueShopping.classList.add('hidden')
  } else {
    dom.wishlistActions.classList.add('!hidden')
    dom.wishlistActions.classList.remove('flex')
    dom.continueShopping.classList.add('flex')
    dom.continueShopping.classList.remove('hidden')
  }
}

const onSuccess = (removedProduct) => {
  console.log(`Successfully removed many Products from the List`, removedProduct)
  _swat.fetch((products) => {
    updateActionsVisibility(products)
    dom.wishlistCount.innerHTML = products.length
  })
}

const onError = (error) => {
  console.log("Error while removing many Products from the List", error)
}

const initWishlistSend = () => {
  const shareSendBtn = document.querySelector(`[data-popup] [${qs.shareSendBtn}]`)
  const shareSenderName = document.querySelector(`[data-popup] [${qs.shareSenderName}]`)
  const shareToEmail = document.querySelector(`[data-popup] [${qs.shareToEmail}]`)
  const shareMessage = document.querySelector(`[data-popup] [${qs.shareMessage}]`)
  
  shareSendBtn.addEventListener('click', () => {
    _swat.sendListViaEmail(
      {
        toEmailId: shareToEmail.value,
        fromName: shareSenderName.value,
        note: shareMessage.value,
        lid: null,
      },
      function (r) {
        const clickEvent = new Event('click')
        const close = document.querySelector('[data-popup-close]')
        close.dispatchEvent(clickEvent)
        setTimeout(() => {
          window.openPopup(dom.shareSuccessHtml.innerHTML)
        }, 500)
      },
      function (r) {
        console.log('Error', r)
      }
    )
  })
}

export const setupAccount = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.loginForm) setupForm(dom.loginForm)
  if(dom.recoverForm) setupForm(dom.recoverForm)
  if(dom.registerForm) setupForm(dom.registerForm)
  if(dom.resetForm) setupForm(dom.resetForm)
  dom.accountNavs.forEach((accountNav) => {
    accountNav.addEventListener('click', () => {
      dom.accountNavs.forEach((navItem) => {
        if(navItem == accountNav) {
          navItem.closest('li').classList.remove('hover:bg-fore', 'hover:text-back')
          navItem.closest('li').classList.add('bg-fore', 'text-back')
        } else {
          navItem.closest('li').classList.add('hover:bg-fore', 'hover:text-back')
          navItem.closest('li').classList.remove('bg-fore', 'text-back')
        }
      })
    })
  })
  if(dom.addressAdd) {
    dom.addressAdd.addEventListener('click', (e) => {
      store.dispatch(setAddress(JSON.parse(dom.newAddressData.innerHTML)))
      store.dispatch(setOpen(true))
    })
  }
  dom.editAddressBtns.forEach((editAddress) => {
    editAddress.addEventListener('click', (e) => {
      store.dispatch(setAddress(JSON.parse(e.target.closest('[data-address]').querySelector('[data-edit-address-data]').innerHTML)))
      store.dispatch(setOpen(true))
    })
  })
  dom.removeAddressBtns.forEach(removeAddressBtn => {
    removeAddressBtn.addEventListener('click', (e) => {
      e.preventDefault()
      if (confirm(removeAddressBtn.dataset.confirmMessage)) {
        fetch(removeAddressBtn.dataset.target, {
          method: 'DELETE',
        })
        .then(response => response.text())
        .then(response => {
          location.reload()
        })
        .catch((error) => {
          console.error('Error:', error)
        })
      }
    })
  })
  dom.accountUrls.forEach((accountUrl) => {
    const navUrl = accountUrl.dataset.accountUrl
    const pathName = location.href.split('?')[0].replace(location.origin, '') 
    if(typeof navUrl != 'undefined' && navUrl) {
      if(navUrl == pathName) {
        accountUrl.classList.add('bg-fore', 'text-back')
        accountUrl.classList.remove('hover:bg-fore', 'hover:text-back')
      } else {
        accountUrl.classList.remove('bg-fore', 'text-back')
        accountUrl.classList.add('hover:bg-fore', 'hover:text-back')
      }
    }
  })
  if(dom.wishlist) {
    const swatTimer = setInterval(() => {
      if(typeof window._swat != 'undefined' && window._swat && window._swat.fetch) {
        clearInterval(swatTimer)
        setTimeout(() => {
          _swat.fetch((products) => {
            console.log(products)
            updateActionsVisibility(products)
            dom.wishlistCount.innerHTML = products.length
            const skus = products.map((product) => product.sku).filter(Boolean)
            if(skus.length > 0) {
              getXgenProducts((results) => {
                console.log('swym products', results)  
                results.forEach((result) => {
                  dom.wishlist.innerHTML +=  `<div class="h-full" product-tile props='${JSON.stringify({...result, context: 'wishlist'}).replace("'", "'")}'></div>`
                })
                window.setupProductTiles(dom.wishlist.querySelectorAll('[product-tile]:empty'))
                setTimeout(() => {
                  const removeBtns = document.querySelectorAll(`[${qsAll.removeFromWishlist}]`)
                  removeBtns.forEach(removeBtn => {
                    removeBtn.addEventListener('click', (e) => {
                      e.preventDefault()
                      const variantId = removeBtn.dataset.wishlistRemove.replace('gid://shopify/ProductVariant/', '')
                      const swymProducts = products.filter(product => product.epi == parseInt(variantId))
                      if(swymProducts.length > 0) {
                        _swat.removeFromWishList(swymProducts[0], onSuccess, onError)
                        removeBtn.closest('[product-tile]').remove()
                      }
                    })
                  })
                }, 500)
              }, skus)
            }
          })
        }, 300)
      }
    }, 100)
    dom.removeAllFromWishlist.addEventListener('click', () => {
      _swat.fetch((products) => {
        products.forEach((product, index) => {
          if(index == products.length - 1)
            _swat.removeFromWishList(product, onSuccess, onError)
          else
            _swat.removeFromWishList(product)
        })
        dom.wishlist.innerHTML = ''
      })
    })
    dom.shareWishlist.addEventListener('click', () => {
      window.openPopup(dom.shareHtml.innerHTML)
      initWishlistSend()
    })
  }
}